function getOptions(tab: string) {
  if (tab === "Glass Details") {
    return (
      <>
        <option value={"salesOrder"}>Sales Order</option>
        <option value={"invoiceNumber"}>Invoice</option>
      </>
    );
  }

  const role = JSON.parse(sessionStorage.getItem("role") || JSON.stringify(""));

  if (tab === "Sales Report") {
    const email = JSON.parse(
      sessionStorage.getItem("email") || JSON.stringify(""),
    );

    if (role === "Outside Sales" && email !== "george@agmillworks.com") {
      return (
        <>
          <option value={"date"}>Date</option>
          <option value={"dealer"}>Dealer</option>
          <option value={"comments"}>Comments</option>
        </>
      );
    }

    return (
      <>
        <option value={"date"}>Date</option>
        <option value={"agRep"}>AG Rep</option>
        <option value={"dealer"}>Dealer</option>
        <option value={"comments"}>Comments</option>
      </>
    );
  }

  if (tab === "Customer List") {
    const email = JSON.parse(
      sessionStorage.getItem("email") || JSON.stringify(""),
    );

    if (role === "Outside Sales" && email !== "george@agmillworks.com") {
      return (
        <>
          <option value={"dealer"}>Dealer</option>
          <option value={"dealerRep"}>Dealer Rep</option>
          <option value={"email"}>Email</option>
        </>
      );
    }

    return (
      <>
        <option value={"agSalesRep"}>AG Rep</option>
        <option value={"dealer"}>Dealer</option>
        <option value={"dealerRep"}>Dealer Rep</option>
        <option value={"email"}>Email</option>
      </>
    );
  }

  if (tab === "Service Repair") {
    const admins = ["Admin", "Inside Sales", "Outside Sales"];

    if (admins.includes(role)) {
      return (
        <>
          <option value={"createdAt"}>Date Created</option>
          <option value={"customerName"}>Customer Name</option>
          <option value={"snNumber"}>Service Number</option>
          <option value={"poNumber"}>PO Number</option>
          <option value={"dealer"}>Dealer</option>
          <option value={"status"}>Status</option>
        </>
      );
    }

    return (
      <>
        <option value={"createdAt"}>Date Created</option>
        <option value={"customerName"}>Customer Name</option>
        <option value={"snNumber"}>Service Number</option>
        <option value={"poNumber"}>PO Number</option>
        <option value={"status"}>Status</option>
      </>
    );
  }

  if (tab === "Calendar") {
    return (
      <>
        <option value={"salesOrder"}>Sales Order</option>
        <option value={"snNumber"}>Service Number</option>
      </>
    );
  }

  if (role === "Production") {
    return (
      <>
        <option value={"quoteNumber"}>Quote Number</option>
        <option value={"jobName"}>Project Name</option>
        <option value={"poNumber"}>PO Number</option>
        <option value={"dealer"}>Dealer</option>
        <option value={"salesperson"}>Dealer Rep</option>
        <option value={"salesOrder"}>Sales Order Number</option>
      </>
    );
  }

  if (role === "Admin" || role === "Inside Sales" || role === "Outside Sales") {
    return (
      <>
        <option value={"createdAt"}>Date Created</option>
        <option value={"customerName"}>Customer Name</option>
        <option value={"quoteNumber"}>Quote Number</option>
        <option value={"jobName"}>Project Name</option>
        <option value={"poNumber"}>PO Number</option>
        {role !== "Outside Sales" && (
          <option value={"agSalesperson"}>AG Rep</option>
        )}
        <option value={"dealer"}>Dealer</option>
        <option value={"salesperson"}>Dealer Rep</option>
        {tab === "Orders" && (
          <>
            <option value={"salesOrder"}>Sales Order Number</option>
            <option value={"invoiceNumber"}>Invoice Number</option>
            <option value={"status"}>Status</option>
          </>
        )}
        {
          tab === "Insights" && <option value={"leadNumber"}>Lead Number</option>
        }
        <option value={"units.doorType"}>Unit Type</option>
      </>
    );
  }

  return (
    <>
      <option value={"createdAt"}>Date Created</option>
      <option value={"customerName"}>Customer Name</option>
      <option value={"quoteNumber"}>Quote Number</option>
      <option value={"jobName"}>Project Name</option>
      <option value={"poNumber"}>PO Number</option>
      {(role === "Manager" || role === "Manager II" || role === "Company Manager") && (
        <option value={"salesperson"}>Dealer Rep</option>
      )}
      {tab === "Orders" && <option value={"status"}>Status</option>}
    </>
  );
}

export default getOptions